import httpService from "./httpService";

export const getUserStatus = async () => {
	const params = {
		platform_id: import.meta.env.VITE_SYSTEM_ID,
	};
	return await httpService.get(`/api/v1/public/user-status`, { params });
};

export const userChangeStatus = async (status: boolean) => {
	const params = {
		platform_id: import.meta.env.VITE_SYSTEM_ID,
		hidden_status: status,
	};

	return await httpService.post(`/api/v1/public/user-status`, params);
};
